import debounce from "../helpers/debounce";

class NavItem {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.link = self.elem.querySelector('[data-nav-item-link]');
        self.dropdown = self.elem.querySelector('[data-nav-item-dropdown]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;
        
        self.link.addEventListener('click', evt => {
            evt.preventDefault();

            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });
    }

    open() {
        let self = this;

        self.elem.classList.add('is-open');
        self.link.setAttribute('aria-expanded', true);
        
        // Add event listeners
        self.addEventListeners();

        self.isOpen = true;
    }

    close() {
        let self = this;

        self.elem.classList.remove('is-open');
        self.link.setAttribute('aria-expanded', false);
        
        // Remove event listeners
        self.removeEventListeners();

        self.isOpen = false;
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        if (evt.target !== self.dropdown && !self.dropdown.contains(evt.target) && evt.target !== self.link && !self.link.contains(evt.target)) {

            // Close the dropdown
            self.close();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }
}

export default NavItem;